// frontend/src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./styles.css";  // Keep Tailwind
import App from "./App";

import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);